import { LoggedUser } from '../models/Person';
import { routes } from '../routes/routes';

type OwnProfileUser = Pick<LoggedUser, 'id' | 'isMentor' | 'isGuest' | 'isAdmin'>;

/** Public "view my profile" nav target for the signed-in user. */
export function ownPublicProfilePath(user: OwnProfileUser): string | null {
  if (!user.id || user.isAdmin) {
    return null;
  }
  if (user.isMentor) {
    return routes.MENTOR.replace(':id', String(user.id));
  }
  if (user.isGuest) {
    return routes.profile;
  }
  return routes.MENTEE.replace(':id', String(user.id));
}

/** Post-save destination after editing profile settings. */
export function ownProfilePathAfterUpdate(
  user: Pick<LoggedUser, 'isMentor' | 'isGuest'>,
  userId: number | string,
): string {
  if (user.isGuest) {
    return routes.profile;
  }
  const route = user.isMentor ? routes.MENTOR : routes.MENTEE;
  return route.replace(':id', String(userId));
}
